import React, { useState } from 'react';
import { AlertTriangle, AlertCircle, Send } from 'lucide-react';
import { formatearFechaCompleta, formatearPrecio } from '../../../../utils/utils';
import DescripcionActividadSolicitud from '../components/infoSolicitudes';
import PreguntasComponent from '../Modulos/Preguntas';

const TutorView = ({ 
  solicitud, 
  usuario, 
  haCotizado, 
  cotizacionUsuario, 
  rechazarSolicitud, 
  setShowModalCotizar, 
  nombreEmpresaReal,
  isAdmin,
  handleEnviarPregunta
}) => {
  const [tab, setTab] = useState('descripcion');

  return (
    <div className="space-y-6">
      {/* Navegación de tabs */}
      <div className="border-b border-gray-200 mb-4">
        <div className="flex">
          <button 
            className={`py-2 px-4 border-b-2 ${tab === 'descripcion' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500'} font-medium transition-colors`}
            onClick={() => setTab('descripcion')}
          >
            Descripción
          </button>
          <button 
            className={`py-2 px-4 border-b-2 ${tab === 'preguntas' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500'} font-medium transition-colors`}
            onClick={() => setTab('preguntas')}
          >
            Preguntas {solicitud.preguntas?.length > 0 && `(${solicitud.preguntas.length})`}
          </button>
        </div>
      </div>

      {/* Contenido de los tabs */}
      <div className="mb-6">
        
        {tab === 'descripcion' && (
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-gray-50 p-3 rounded-lg border border-gray-100">
                <label className="text-xs text-gray-500 uppercase font-bold block mb-1">Tipo de Servicio</label>
                <span className="font-medium text-gray-800">{solicitud.Servicio || 'No especificado'}</span>
              </div>
              <div className="bg-gray-50 p-3 rounded-lg border border-gray-100">
                <label className="text-xs text-gray-500 uppercase font-bold block mb-1">Materia</label>
                <span className="font-medium text-gray-800">{solicitud.materia || 'No especificada'}</span>
              </div>
              <div className="bg-gray-50 p-3 rounded-lg border border-gray-100">
                <label className="text-xs text-gray-500 uppercase font-bold block mb-1">Fecha de Entrega</label>
                <span className="font-medium text-gray-800">
                  {formatearFechaCompleta(solicitud.fechaentrega)}
                </span>
              </div>
              <div className="bg-gray-50 p-3 rounded-lg border border-gray-100">
                <label className="text-xs text-gray-500 uppercase font-bold block mb-1">Id Solicitud</label>
                <span className="font-medium text-green-600 font-mono">{solicitud.id}</span>
              </div>

              {/* Lógica ProPlataforma para Tutor */}
              {solicitud.esProPlataforma() && (
                <div className="md:col-span-2 mt-4 p-4 border-l-4 border-blue-500 bg-slate-50 rounded-r-lg shadow-sm">
                  <h3 className="text-sm font-bold text-blue-800 uppercase mb-3">Detalles de Plataforma</h3>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                    <div>
                        <label className="text-[10px] text-gray-500 uppercase font-bold block">Fase</label>
                        <p className="text-sm">{solicitud.proPlataforma?.fase || 'N/A'}</p>
                    </div>
                    <div>
                        <label className="text-[10px] text-gray-500 uppercase font-bold block">Plataforma</label>
                        <p className="text-sm">{solicitud.proPlataforma?.plataforma || 'N/A'}</p>
                    </div>
                    <div>
                        <label className="text-[10px] text-gray-500 uppercase font-bold block">Es Colaborativo</label>
                        <p className="text-sm">{solicitud.proPlataforma?.esColaborativo ? 'Sí' : 'No'}</p>
                    </div>
                  </div>

                  {solicitud.proPlataforma?.manejoPlataforma && (
                    <div className="bg-rose-50 border border-red-200 rounded-lg p-4">
                      <div className="flex gap-3">
                        <AlertTriangle className="h-5 w-5 text-red-500 flex-shrink-0" />
                        <div>
                          <p className="font-bold text-sm text-red-900">Manejo de Plataforma Crítico (UNAD)</p>
                          <p className="text-xs text-red-700 mt-1">
                            Requiere gestión de <strong>Foros, trabajos colaborativos y videos.</strong> 
                            Prohibido el uso de IA o plagio.
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="mt-6">
               <DescripcionActividadSolicitud solicitud={solicitud} />
            </div>

            {/* Caja de Acciones / Estado de Cotización */}
            <div className="mt-8 border-t pt-6">
              {haCotizado ? (
                <div className={`p-4 rounded-lg border text-center ${cotizacionUsuario?.cotizacion === -1 ? 'bg-red-50 border-red-200' : 'bg-green-50 border-green-200'}`}>
                  {cotizacionUsuario?.cotizacion === -1 ? (
                    <>
                      <p className="text-red-700 font-bold text-lg">SOLICITUD RECHAZADA</p>
                      <p className="text-sm text-red-600">Rechazaste este trabajo el {formatearFechaCompleta(cotizacionUsuario.fechaconfirmacion)}</p>
                    </>
                  ) : (
                    <>
                      <p className="text-green-700 font-bold text-lg">HAS COTIZADO: {formatearPrecio(cotizacionUsuario?.cotizacion)}</p>
                      <p className="text-sm text-green-600 mb-3">Enviada el {formatearFechaCompleta(cotizacionUsuario?.fechaconfirmacion)}</p>
                      <div className="flex items-center gap-2 justify-center p-2 bg-yellow-50 rounded border border-yellow-100 max-w-md mx-auto">
                        <AlertCircle size={16} className="text-yellow-600" />
                        <p className="text-[11px] text-yellow-700 text-left">
                          Para modificar el precio, contacta con administración.
                        </p>
                      </div>
                    </>
                  )}
                </div>
              ) : (
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <button
                    onClick={() => rechazarSolicitud(nombreEmpresaReal)}
                    className="flex-1 max-w-xs px-6 py-3 border border-gray-300 rounded-xl text-gray-700 bg-white hover:bg-gray-50 font-bold transition-all"
                  >
                    No me interesa
                  </button>
                  <button
                    onClick={() => setShowModalCotizar(true)}
                    className="flex-1 max-w-xs px-6 py-3 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700 shadow-lg shadow-blue-200 transition-all flex items-center justify-center gap-2"
                  >
                    <Send size={18} /> Cotizar Proyecto
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        {tab === 'preguntas' && (
          <PreguntasComponent
            preguntas={solicitud.preguntas || []}
            usuarioActual={usuario}
            isAdmin={isAdmin}
            onEnviarPregunta={handleEnviarPregunta}
            onResponderPregunta={handleEnviarPregunta}
          />
        )}
      </div>
    </div>
  );
};

export default TutorView;